// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  background-color: white;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form.checkout {
  max-width: 500px;
  margin: 2rem auto;
  text-align: center;
  border: 2px solid #eee;
  padding: 3px;
  background-color: #EBF1F7;
  font-family: monospace;
  color: #525252;
  font-size: 1.1rem;
}

form.checkout button {
  width: 100%;
  padding: 0.5rem 1rem;
  color: white;
  background: rgb(26, 127, 203);
  border: none;
  font-weight: 500;
  font-size: 16px;
}

form.checkout button:active {
  background: rgb(23, 82, 137);
}

label {
  color: #8898aa;
  font-size: 13.5px;
}

#form-field {
  padding: 3px;
  background-color: white !important;
}

#card-info {
  min-width: 400px;
}

mat-error {
  display: flex;
  align-items: center;
  justify-content: center;
}

#card-errors {
  padding: 3px;
  font-size: 13px;
}

::ng-deep .mat-mdc-dialog-container {
  overflow: hidden !important;
  background-color: #F6F9FC !important;
}

.image {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cards {
  overflow: hidden;
  position: relative;
  padding: 0 10px;
  height: 55px;
  margin-left: 10px;
}

.cards > div {
  position: relative;
  display: flex;
  flex-direction: column;
  animation-name: card-slide;
  animation-duration: 9s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-delay: 0.3s;
  will-change: transform;
  transform: translateY(0);
}

#information-message {
  color: #67656b;
  font-size: 0.71rem;
  padding: 10px 0;
}

#submit-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

#info-icon {
  margin-left: 5px;
}

@keyframes card-slide {
  0% {
    transform: translateY(0);
  }
  11.11% {
    transform: translateY(0);
  }
  22.22% {
    transform: translateY(-55px);
  }
  33.33% {
    transform: translateY(-55px);
  }
  44.44% {
    transform: translateY(-110px);
  }
  55.55% {
    transform: translateY(-110px);
  }
  66.66% {
    transform: translateY(-165px);
  }
  77.77% {
    transform: translateY(-165px);
  }
  88.88% {
    transform: translateY(-220px);
  }
  100% {
    transform: translateY(-220px);
  }
}
.cards img {
  width: 55px;
}

@media screen and (max-width: 650px) {
  ::ng-deep .cdk-overlay-pane {
    max-width: 100% !important;
    min-width: 95vw !important;
  }
  ::ng-deep mat-dialog-container {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  form {
    width: 95%;
  }
  form.checkout {
    padding: 1rem 5px !important;
  }
  .image {
    flex-direction: column;
  }
  .cards {
    margin-top: 10px;
  }
  #card-info {
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/dialog/stripe-payment/stripe-payment.component.scss"],"names":[],"mappings":"AAAA;;EAEE,sBAAA;EACA,YAAA;EACA,kBAAA;EAEA,kBAAA;EACA,uBAAA;EAGA,iCAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EAEA,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,cAAA;EACA,iBAAA;AAHF;;AAMA;EACE,YAAA;EACA,kCAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,2BAAA;EACA,oCAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAOA;EACE;IACE,wBAAA;EAJF;EAMA;IACE,wBAAA;EAJF;EAMA;IACE,4BAAA;EAJF;EAMA;IACE,4BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;EAMA;IACE,6BAAA;EAJF;AACF;AAOA;EACE,WAAA;AALF;;AASA;EAEE;IACE,0BAAA;IACA,0BAAA;EAPF;EAUA;IACE,4BAAA;IACA,6BAAA;EARF;EAWA;IACE,UAAA;EATF;EAYA;IACE,4BAAA;EAVF;EAaA;IACE,sBAAA;EAXF;EAcA;IACE,gBAAA;EAZF;EAeA;IACE,eAAA;EAbF;AACF","sourcesContent":["input,\n.StripeElement {\n  box-sizing: border-box;\n  height: 40px;\n  padding: 10px 12px;\n  //border: 1px solid transparent;\n  border-radius: 4px;\n  background-color: white;\n  //box-shadow: 0 1px 3px 0 #e6ebf1;\n  -webkit-transition: box-shadow 150ms ease;\n  transition: box-shadow 150ms ease;\n}\n\n.StripeElement--focus {\n  box-shadow: 0 1px 3px 0 #cfd7df;\n}\n\n.StripeElement--invalid {\n  border-color: #fa755a;\n}\n\n.StripeElement--webkit-autofill {\n  background-color: #fefde5 !important;\n}\n\n// for stripe form\nform.checkout {\n  max-width: 500px;\n  margin: 2rem auto;\n  text-align: center;\n  border: 2px solid #eee;\n  padding: 3px;\n  background-color: #EBF1F7;\n  font-family: monospace;\n  color: #525252;\n  font-size: 1.1rem;\n}\n\nform.checkout button {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  color: white;\n  background: rgb(26, 127, 203);\n  border: none;\n  //margin-top: 1rem;\n  font-weight: 500;\n  font-size: 16px;\n}\n\nform.checkout button:active {\n  background: rgb(23, 82, 137);\n}\n\nlabel {\n  color: #8898aa;\n  font-size: 13.5px;\n}\n\n#form-field {\n  padding: 3px;\n  background-color: white !important;\n}\n\n#card-info {\n  min-width: 400px;\n}\n\nmat-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#card-errors {\n  padding: 3px;\n  font-size: 13px;\n}\n\n::ng-deep .mat-mdc-dialog-container {\n  overflow: hidden !important;\n  background-color: #F6F9FC !important;\n}\n\n.image {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.cards {\n  overflow: hidden;\n  position: relative;\n  padding: 0 10px;\n  height: 55px;\n  margin-left: 10px;\n}\n\n.cards > div {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  animation-name: card-slide;\n  animation-duration: 9s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-delay: 0.3s;\n  will-change: transform;\n  transform: translateY(0);\n}\n\n#information-message {\n  color: #67656b;\n  font-size: 0.71rem;\n  padding: 10px 0;\n}\n\n#submit-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#info-icon {\n  margin-left: 5px;\n}\n\n\n@keyframes card-slide {\n  0% {\n    transform: translateY(0);\n  }\n  11.11% {\n    transform: translateY(0);\n  }\n  22.22% {\n    transform: translateY(-55px);\n  }\n  33.33% {\n    transform: translateY(-55px);\n  }\n  44.44% {\n    transform: translateY(-110px);\n  }\n  55.55% {\n    transform: translateY(-110px);\n  }\n  66.66% {\n    transform: translateY(-165px);\n  }\n  77.77% {\n    transform: translateY(-165px);\n  }\n  88.88% {\n    transform: translateY(-220px);\n  }\n  100% {\n    transform: translateY(-220px);\n  }\n}\n\n.cards img {\n  width: 55px;\n}\n\n\n@media screen and (max-width: 650px) {\n\n  ::ng-deep .cdk-overlay-pane {\n    max-width: 100% !important;\n    min-width: 95vw !important;\n  }\n\n  ::ng-deep mat-dialog-container {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n\n  form {\n    width: 95%;\n  }\n\n  form.checkout {\n    padding: 1rem 5px !important;\n  }\n\n  .image {\n    flex-direction: column;\n  }\n\n  .cards {\n    margin-top: 10px;\n  }\n\n  #card-info {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
